/* global SideDrawer */

if (!customElements.get('bt-search-drawer')) {
  class BtSearchDrawer extends SideDrawer {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.searchInput = this.querySelector('.js-search-input');
      this.clickDelegateHandler = this.handleDocumentClick.bind(this);
      this.suggestionChipHandler = this.handleSuggestionChipClick.bind(this);
      document.addEventListener('click', this.clickDelegateHandler);
      this.addEventListener('click', this.suggestionChipHandler);
      this.bindSearchPageLinks();
      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.clickDelegateHandler);
      this.removeEventListener('click', this.suggestionChipHandler);
      document.removeEventListener('dispatch:bt-search-drawer:open', this.openViaEventHandler);
      document.removeEventListener('dispatch:bt-search-drawer:close', this.closeViaEventHandler);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:select', this.sectionSelectHandler);
        document.removeEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }
    }

    handleDocumentClick(evt) {
      const opener = evt.target.closest('.js-open-bt-search-drawer');
      if (!opener || !document.getElementById('bt-search-drawer')) return;
      evt.preventDefault();
      this.open(opener, this.searchInput);
    }

    /**
     * Runs predictive search for trending suggestion chips instead of navigating away.
     * @param {object} evt - Event object.
     */
    handleSuggestionChipClick(evt) {
      const chip = evt.target.closest('.js-search-suggestion-chip');
      if (!chip) return;

      evt.preventDefault();

      const predictiveSearch = this.querySelector('predictive-search');
      const query = chip.dataset.searchQuery
        || chip.querySelector('.bt-search-drawer__chip-text')?.textContent?.trim();
      if (!predictiveSearch || !this.searchInput || !query) return;

      this.searchInput.value = query;
      this.searchInput.setAttribute('value', query);
      predictiveSearch.getResults(query);
      this.searchInput.focus();
    }

    /**
     * Opens drawer when bottom bar (or similar) links to the search page.
     */
    bindSearchPageLinks() {
      const searchPath = (this.dataset.searchPath || '/search').replace(/\/$/, '') || '/search';

      document.querySelectorAll('a[href]').forEach((link) => {
        if (link.dataset.btSearchBound || link.classList.contains('js-open-bt-search-drawer')) return;

        try {
          const url = new URL(link.href, window.location.origin);
          const path = url.pathname.replace(/\/$/, '') || '/';
          if (path !== searchPath && !path.endsWith(searchPath)) return;
        } catch {
          return;
        }

        link.dataset.btSearchBound = 'true';
        link.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.open(link, this.searchInput);
        });
      });
    }

    bindEvents() {
      this.openViaEventHandler = this.handleOpenViaEvent.bind(this);
      this.closeViaEventHandler = this.close.bind(this, null);
      document.addEventListener('dispatch:bt-search-drawer:open', this.openViaEventHandler);
      document.addEventListener('dispatch:bt-search-drawer:close', this.closeViaEventHandler);

      if (Shopify.designMode) {
        this.sectionSelectHandler = this.handleSectionSelect.bind(this);
        this.sectionDeselectHandler = this.handleSectionDeselect.bind(this);
        document.addEventListener('shopify:section:select', this.sectionSelectHandler);
        document.addEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }
    }

    handleOpenViaEvent(evt) {
      this.open(evt.detail?.opener || null, this.searchInput);
    }

    handleSectionSelect(evt) {
      if (evt.target === this.closest('.shopify-section')) this.open(null, this.searchInput);
    }

    handleSectionDeselect(evt) {
      if (evt.target === this.closest('.shopify-section')) this.close();
    }

    open(opener, elementToFocus) {
      this.overlay?.classList.add('overlay--bt-search');
      super.open(opener, elementToFocus || this.searchInput, () => {
        if (this.searchInput) this.searchInput.focus();
      });
    }

    close(callback) {
      const predictive = this.querySelector('predictive-search');
      if (predictive?.close) predictive.close();
      super.close(() => {
        this.overlay?.classList.remove('overlay--bt-search');
        if (callback) callback();
      });
    }
  }

  customElements.define('bt-search-drawer', BtSearchDrawer);
}
